import { useState } from 'react';
import { CONSUMER_PAYMENT_SCHEDULES, DEFAULT_CONSUMER_PAYMENT_SCHEDULE } from '@shared/consumerPlan';
import { ChoiceList } from '../components/choice-list';
import { StepFrame } from '../components/step-frame';
import { useConsumerFlow } from '../hooks/use-consumer-flow';
import { useConsumerPlan } from '../hooks/use-consumer-plan';
import { COVERAGE_LANE_COPY } from '../lib/copy';
import type { ConsumerStepProps } from './step-props';

export function PaymentPreferenceStep({ clientId }: ConsumerStepProps) {
  const { goTo, back } = useConsumerFlow(clientId);
  const { plan, updatePlan } = useConsumerPlan(clientId);
  const [schedule, setSchedule] = useState<ConsumerPaymentSchedule>(
    plan?.paymentSchedule ?? DEFAULT_CONSUMER_PAYMENT_SCHEDULE,
  );

  const handleContinue = () => {
    updatePlan({ paymentSchedule: schedule });
    goTo('searching');
  };

  return (
    <StepFrame
      step="payment-preference"
      title="How would you like to pay for coverage?"
      subtitle="We’ll show three options that fit how you’d like to pay. You can switch any time."
      onBack={() => back('scenario')}
      primary={{ label: 'Show my options', onClick: handleContinue }}
      next="find the options that pay the most toward your care."
    >
      <ChoiceList
        label="How you’d like to pay"
        value={schedule}
        onChange={setSchedule}
        choices={CONSUMER_PAYMENT_SCHEDULES.map(value => ({
          value,
          title: COVERAGE_LANE_COPY[value].title,
          description: COVERAGE_LANE_COPY[value].description,
          badge: value === DEFAULT_CONSUMER_PAYMENT_SCHEDULE ? 'Most popular' : undefined,
        }))}
      />
    </StepFrame>
  );
}
